import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { SharedModule } from '../shared/shared.module';
import { ConversionBarComponent } from './components/scenario-panel/conversion-bar/conversion-bar.component';
import { DescriptionComponent } from './components/description/description.component';
import { DescriptionMainComponent } from './components/description/description-main/description-main.component';
import { DescriptionConsumerComponent } from './components/description/description-consumer/description-consumer.component';
import { DescriptionProducerListComponent } from './components/description/description-producer-list/description-producer-list.component';
import { DescriptionProducerComponent } from './components/description/description-producer/description-producer.component';
import { DescriptionObjectTypeComponent } from './components/description/description-object-type/description-object-type.component';
import { EnergyMapComponent } from './energy-map.component';
import { ExpansionConversionBarComponent } from './components/scenario-panel/expansion-conversion-bar/expansion-conversion-bar.component';
import { LampCardComponent } from './components/lamp-card/lamp-card.component';
import { PerformanceQuestionnaireComponent } from './components/detail/performance-questionnaire/performance-questionnaire.component';
import { ProductCatalogComponent } from './components/product-catalog/product-catalog.component';
import { ProductDetailComponent } from './components/product-detail/product-detail.component';
import { ScenarioPanelComponent } from './components/scenario-panel/scenario-panel.component';
import { StreetLightPlannerSidebarScenarioComponent } from './components/street-light-planner-sidebar-scenario/street-light-planner-sidebar-scenario.component';
import { StreetLightPlannerSidebarNewScenarioComponent } from './components/street-light-planner-sidebar-new-scenario/street-light-planner-sidebar-new-scenario.component';
import { StreetLightPlannerStep1Component } from './components/street-light-planner-sidebar-new-scenario/street-light-planner-step1/street-light-planner-step1.component';
import { StreetLightPlannerStep2Component } from './components/street-light-planner-sidebar-new-scenario/street-light-planner-step2/street-light-planner-step2.component';
import { StreetLightPlannerStep2ManualComponent } from './components/street-light-planner-sidebar-new-scenario/street-light-planner-step2-manual/street-light-planner-step2-manual.component';
import { StreetLightPlannerStep3Component } from './components/street-light-planner-sidebar-new-scenario/street-light-planner-step3/street-light-planner-step3.component';
import { StreetLightPlannerStep4Component } from './components/street-light-planner-sidebar-new-scenario/street-light-planner-step4/street-light-planner-step4.component';
import { SettingsPanelComponent } from './components/settings-panel/settings-panel.component';
import { StreetLightPlannerManualComponent } from './components/street-light-planner-sidebar-new-scenario/street-light-planner-manual/street-light-planner-manual.component';
import { StreetLightPlannerRecommendedComponent } from './components/street-light-planner-sidebar-new-scenario/street-light-planner-recommended/street-light-planner-recommended.component';
import { BuildingIconComponent } from './components/building-icon/building-icon.component';
import { BuildingDetailsComponent } from './components/description/description-consumer/building-details/building-details.component';
import { MeterListComponent } from './components/description/description-consumer/meter-list/meter-list.component';
import { EditBuildingComponent } from './components/edit-building/edit-building.component';
import { EditLocationComponent } from './components/edit-building/edit-location/edit-location.component';
import { DescriptionSensorComponent } from './components/description/description-sensor/description-sensor.component';
import { NewBuildingsOptionComponent } from './components-new/buildings-option/new-buildings-option.component';
import { NewLegendsComponent } from './components-new/legends/new-legends.component';
import { MapHeaderControlsComponent } from './components-new/map-header-controls/map-header-controls.component';
import { MapSideControlsComponent } from './components-new/map-side-controls/map-side-controls.component';
import { GpsAndTypeBuildingsOptionComponent } from './components-new/gps-and-type-buildings-option/gps-and-type-buildings-option.component';
import { SensorListComponent } from './components/description/description-consumer/sensor-list/sensor-list.component';
import { MapPopupComponent } from './map-popup/map-popup.component';
import { LampPopupComponent } from './map-popup/lamp-popup/lamp-popup.component';
import { BuildingHistoryDialogComponent } from './dialog/building-history-dialog/building-history-dialog.component';
import { SaveScenarioDialogComponent } from './dialog/save-scenario-dialog/save-scenario-dialog.component';
import { SaveScenarioExcelDialogComponent } from './dialog/save-scenario-excel-dialog/save-scenario-excel-dialog.component';
import { StreetlightEfficiencyDialogComponent } from './dialog/streetlight-efficiency-dialog/streetlight-efficiency-dialog.component';
import { EmailScenarioDialogComponent } from './dialog/email-scenario-dialog/email-scenario-dialog.component';
import { LoadScenarioDialogComponent } from './dialog/load-scenario-dialog/load-scenario-dialog.component';
import { ScenarioItemComponent } from './dialog/load-scenario-dialog/scenario-item/scenario-item.component';
import { EfficiencyAnalysisModule } from '@app/efficiency-analysis/efficiency-analysis.module';
import { ContactPageModule } from '@app/contact-page/contact-page.module';
import { EnergyTypeIconComponent } from './components/energy-type-icon/energy-type-icon.component';

@NgModule({
  imports: [CommonModule, RouterModule, SharedModule, EfficiencyAnalysisModule, ContactPageModule],
  declarations: [
    ConversionBarComponent,
    DescriptionComponent,
    DescriptionMainComponent,
    DescriptionConsumerComponent,
    DescriptionProducerListComponent,
    DescriptionProducerComponent,
    DescriptionObjectTypeComponent,
    EnergyMapComponent,
    ExpansionConversionBarComponent,
    LampCardComponent,
    PerformanceQuestionnaireComponent,
    ProductCatalogComponent,
    ProductDetailComponent,
    ScenarioPanelComponent,
    StreetLightPlannerSidebarScenarioComponent,
    StreetLightPlannerSidebarNewScenarioComponent,
    StreetLightPlannerStep1Component,
    StreetLightPlannerStep2Component,
    StreetLightPlannerStep2ManualComponent,
    StreetLightPlannerStep3Component,
    StreetLightPlannerStep4Component,
    SettingsPanelComponent,
    StreetLightPlannerManualComponent,
    StreetLightPlannerRecommendedComponent,
    BuildingIconComponent,
    BuildingDetailsComponent,
    MeterListComponent,
    EditBuildingComponent,
    EditLocationComponent,
    DescriptionSensorComponent,
    EnergyMapComponent,
    NewBuildingsOptionComponent,
    NewLegendsComponent,
    MapHeaderControlsComponent,
    MapSideControlsComponent,
    GpsAndTypeBuildingsOptionComponent,
    SensorListComponent,
    MapPopupComponent,
    LampPopupComponent,
    BuildingHistoryDialogComponent,
    SaveScenarioDialogComponent,
    SaveScenarioExcelDialogComponent,
    StreetlightEfficiencyDialogComponent,
    EmailScenarioDialogComponent,
    LoadScenarioDialogComponent,
    ScenarioItemComponent,
    EnergyTypeIconComponent,
  ],
})
export class EnergyMapModule {}
